import axios from "./api";

//获取用户信息
export const getInfo = () => {
  return axios({
    url: "/v2/user/getinfo",
    method: "post",
    loading: true
  });
};

//注册页面-账号密码登录
export const login = data => {
  return axios({
    url: "/v2/user/login",
    method: "post",
    loading: true,
    data
  });
};

//注册页面-手机号验证码登录
export const smslogin = data => {
  return axios({
    url: "/v2/user/smslogin",
    method: "post",
    loading: true,
    data,
    silent: [2016]
  });
};

//退出
export const logout = () => {
  return axios({
    url: "/v2/user/logout",
    loading: true
  });
};

//手机号防刷安全码
export const getCode = () => {
  return axios({
    url: "/v2/user/geticode",
    loading: true,
    method: "get"
  });
};

//注册页面-未注册发送验证码
export const beforeLoginSends = data => {
  return axios({
    url: "/v2/user/beforeloginsendsms",
    loading: true,
    method: "post",
    data
  });
};

//注册页面-未注册手机注册
export const msmsreg = data => {
  return axios({
    url: "/v2/user/msmsreg",
    method: "post",
    loading: true,
    data
  });
};

//验证账号是否绑定手机
export const verifyPhoneBind = data => {
  return axios({
    url: "/v2/user/verifyphonebind",
    method: "post",
    loading: true,
    data,
    silent: [5003]
  });
};

//给该账号的绑定手机验证码校验

export const checkCode = data => {
  return axios({
    url: "/v2/user/checkcode",
    method: "post",
    loading: true,
    data
  });
};

// 获取验证码 --账号中心
export const sendCodeU = data => {
  return axios({
    url: "/v2/user/sendSms",
    method: "post",
    loading: true,
    data
  });
};

// 找回账号
export const findAccount = data => {
  return axios({
    url: "/v2/user/findAccount",
    method: "post",
    loading: true,
    data
  });
};

// 发送账号信息
export const sendAccount = data => {
  return axios({
    url: "/v2/user/sendAccount",
    method: "post",
    loading: true,
    data
  });
};
